import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

export const GroupIcon: FunctionComponent<SvgIconProps> = (props) => (
	<SvgIcon
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			d="M4 3H5V5H3V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3ZM20 3C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4V5H19V3H20ZM15 5V3H17V5H15ZM11 5V3H13V5H11ZM7 5V3H9V5H7ZM21 20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H19V19H21V20ZM15 21V19H17V21H15ZM11 21V19H13V21H11ZM7 21V19H9V21H7ZM4 21C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V19H5V21H4ZM3 15H5V17H3V15ZM21 15V17H19V15H21ZM3 11H5V13H3V11ZM21 11V13H19V11H21ZM3 7H5V9H3V7ZM21 7V9H19V7H21Z"
			fill="#79818F"
		/>
	</SvgIcon>
);

export default GroupIcon;
